import { requiredContactFields, requiredContactMissing } from '@ehr/shared';
import { ApiError } from './api.js';

/**
 * ehr#733 / ehr#734: Contact Info's required phones on the Demographics drawer and the Add
 * client window. Rules live in @ehr/shared (required-contact.ts); these are the screen's helpers.
 */

/** Blank required phones a Save record refuses, as the drawer's missing-field entries. */
export function contactSaveMissing(
  contact: unknown,
  draft: boolean,
): { sec: string; field: string; label: string }[] {
  if (draft) return [];
  return requiredContactMissing(contact).map((m) => ({
    sec: 'contact',
    field: m.field,
    label: m.field === 'mobilePhone' ? m.label : `${m.label} (a box under it is ticked)`,
  }));
}

/** A Contact Info field's label, with the red-star marker while the field is required. */
export function contactFieldLabel(contact: unknown, field: string, label: string): string {
  if (label.endsWith('*')) return label;
  return requiredContactFields(contact).includes(field) ? `${label} *` : label;
}

/** The fields a CONTACT_FIELD_REQUIRED refusal names (to mark red), else null. */
export function requiredContactRefusal(e: unknown): string[] | null {
  if (!(e instanceof ApiError) || e.code !== 'CONTACT_FIELD_REQUIRED') return null;
  const fields = (e.details as { fields?: unknown } | undefined)?.fields;
  return Array.isArray(fields) && fields.length ? fields.map(String) : ['contact.mobilePhone'];
}

/** ehr#734: the Add client window's Mobile phone is required for a client (not other types). */
export function newClientMobileMissing(category: string, mobile: string | undefined): boolean {
  return category === 'client' && !(mobile ?? '').trim();
}

/** The line under a required phone left blank ("" when the field is not a blank required one). */
export function requiredContactMessage(contact: unknown, field: string): string {
  return requiredContactMissing(contact).find((m) => m.field === field)?.message ?? '';
}
